import { render } from "./ViewMarks.vue?vue&type=template&id=17db7262&scoped=true"
import script from "./ViewMarks.vue?vue&type=script&lang=js"
export * from "./ViewMarks.vue?vue&type=script&lang=js"

import "./ViewMarks.vue?vue&type=style&index=0&id=17db7262&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2025-2026.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17db7262"]])

export default __exports__